import React, { useRef } from 'react';
import PropTypes from 'prop-types';

import { t } from '../../services/i18nService';
import modalStyles from '../../styles/generic/modal.scss';
import alertStyles from './alertTemplate.scss';
import EssayRestoreScrim from './EssayRestoreScrim';
import EssayRestoreStatusIcon from './EssayRestoreStatusIcon';
import useEssayRestoreModalFocus, { ESSAY_RESTORE_CARD_ATTRIBUTE } from './useEssayRestoreModalFocus';

/** Confirmation shown after a restore. */
const EssayRestoredAlert = ({ extraClasses, handleClose, id }) => {
    const cardRef = useRef(null);

    useEssayRestoreModalFocus(cardRef);

    return (
        <div
            className={`${extraClasses} ${alertStyles.essayRestoreAlert}`}
            id={id}
            role="dialog"
            aria-modal="true"
            aria-labelledby="essayRestoredCardTitle"
            tabIndex="-1"
            ref={cardRef}
            {...{ [ESSAY_RESTORE_CARD_ATTRIBUTE]: true }}
        >
            <EssayRestoreScrim />
            <div
                id="essayRestoredCard"
                className={`${modalStyles.modalContentWrapper} ${alertStyles.essayRestoreAlertCard}`}
            >
                <h3
                    id="essayRestoredCardTitle"
                    className={`${modalStyles.modalTitle} ${alertStyles.essayRestoreAlertHeader}`}
                >
                    <EssayRestoreStatusIcon type="success" className={alertStyles.essayRestoreAlertSuccessIcon} />
                    <span dangerouslySetInnerHTML={{ __html: t('contentRestore.success.title') }} />
                </h3>

                <div className={`${modalStyles.modalContent} ${alertStyles.essayRestoreAlertBody}`}>
                    <p className={modalStyles.modalContentPart}>
                        <span dangerouslySetInnerHTML={{ __html: t('contentRestore.success.message') }} />
                    </p>
                </div>

                <div className={`${modalStyles.modalFooterButtons} ${alertStyles.essayRestoreAlertActions}`}>
                    <button
                        type="button"
                        id="essayRestoredDoneBtn"
                        className={`btn default-btn ${modalStyles.modalMainBtn} ${alertStyles.essayRestoreAlertButton}`}
                        onClick={handleClose}
                    >
                        {t('contentRestore.success.done')}
                    </button>
                </div>
            </div>
        </div>
    );
};

EssayRestoredAlert.propTypes = {
    extraClasses: PropTypes.string,
    handleClose: PropTypes.func,
    id: PropTypes.string,
};

export default EssayRestoredAlert;
